import Vue from 'vue'
import VueRouter from 'vue-router'

import login from './login'
import members from './members'
import settings from './settings'
import users from './users'
import seatingStatus from './seatingStatus'

Vue.use(VueRouter)

const routes = [
  ...login,
  ...members,
  ...settings,
  ...users,
  ...seatingStatus
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
